import {Component, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {BaseGridComponent} from 'app/core-ui/abstract/basegrid/basegrid.component';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LedgerService} from 'app/core-ui/abstract/services/ledger.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {SecurityService} from 'app/core-ui/abstract/services/security.service';
import {VisualsService} from 'app/core-ui/abstract/services/visuals.service';
import {throwError} from 'rxjs';
import {RepLedgerDemandsService} from './repLedgerDemands.service';

//generic
//specific
@Component({
  selector: 'repLedgerDemands-grid',
  templateUrl: './repLedgerDemands.component.html',
  providers: [RepLedgerDemandsService, LedgerService],
})
export class RepLedgerDemandsComponent extends BaseGridComponent<RepLedgerDemandsService> {
  @ViewChild('DynamicFormComponent') public form: any;

  constructor(
    public gridService: RepLedgerDemandsService,
    public eventsEmitterService: EventsEmitterService,
    public securityService: SecurityService,
    logger: LogService,
    visualsService: VisualsService,
    public route: ActivatedRoute,
    public ledgerService: LedgerService,
  ) {
    super(securityService, logger, visualsService, gridService, 'repLedgerDemands');

    this.loadVisuals();
    this.eventsEmitterService.languageChange.subscribe({
      next: (langId) => {
        this.loadVisuals();
        this.getValidationMessages();
      },
    });
  }

  afterFormInit(formConfig: any) {
    this.route.params.subscribe({
      next: (params) => {
        this.logger.log(params);
        // Defaults to null if no query param provided.
        // (+) converts string 'id' to a number
        if (params['id']) {
          this.form.setValue('clientVAT', +params['clientVAT']);
          this.submit(this.form.value);
        }
      },
    });
  }

  //Grid Search Form Modal Handler
  handleModalOutput(event: any) {
    this.form.setValue('accId', event.value);
  }

  public doAcceptAssignment(params) {
    this.loading = true;
    params.changeStatus = 'assigment accepted';
    this.ledgerService.changeDemand(params).subscribe({
      next: (data) => {
        if (data.success == true) {
          LogService.emitAlert({
            type: 'success',
            msg: this.visuals['acceptanceSucceded'],
            timeout: 3000,
          });
          this.loading = false;
        } else {
          LogService.emitAlert({
            type: 'danger',
            msg: this.visuals['acceptanceFailed'],
            timeout: 3000,
          });
        }
        this.search();
      },
      error: (error) => {
        this.loading = false;
        this.search();
        return throwError(() => new Error(error));
      },
    });
  }

  public doFinance(params) {
    this.loading = true;
    params.changeStatus = 'financed';
    this.ledgerService.changeDemand(params).subscribe({
      next: (data) => {
        if (data.success == true) {
          LogService.emitAlert({
            type: 'success',
            msg: this.visuals['financeSucceded'],
            timeout: 3000,
          });
          this.loading = false;
        } else {
          LogService.emitAlert({
            type: 'danger',
            msg: this.visuals['financeFailed'],
            timeout: 3000,
          });
        }
        //this.bean = this.instantiateBean();
        this.search();
      },
      error: (error) => {
        this.loading = false;
        //this.bean = this.instantiateBean();
        this.search();
        return throwError(() => new Error(error));
      },
    });
  }

  public doConfirmPayment(params) {
    this.loading = true;
    params.changeStatus = 'payment confirmed';
    this.ledgerService.changeDemand(params).subscribe({
      next: (data) => {
        if (data.success == true) {
          LogService.emitAlert({
            type: 'success',
            body: this.visuals['paymentConfirmationSucceded'],
          });
          this.loading = false;
        } else {
          LogService.emitAlert({
            type: 'error',
            body: this.visuals['paymentConfirmationFailed'],
          });
        }
        //this.bean = this.instantiateBean();
        this.search();
      },
      error: (error) => {
        this.loading = false;
        //this.bean = this.instantiateBean();
        this.search();
        return throwError(() => new Error(error));
      },
    });
  }
}
